import { ClientBrandCode } from '@domgen/dgx-fe-common';
import { ApplianceDetailsSteppedIpsFormConfig } from '../../models/appliance-details-stepped/appliance-details-stepped-ips-form-config.interface';
import { mockApplianceDetailsSteppedIpsFormValue } from './appliance-details-stepped-ips-form-value.mock';
import { mockCmsApplianceDetailsSteppedForm } from './cms-appliance-details-stepped-form.mock';

export const mockApplianceDetailsSteppedIpsFormConfig: ApplianceDetailsSteppedIpsFormConfig =
  {
    applianceMaximumAge: new Date(),
    clientBrandCode: ClientBrandCode.Beko,
    cmsData: mockCmsApplianceDetailsSteppedForm,
    initialValue: mockApplianceDetailsSteppedIpsFormValue,
  };
